/**
 * Created by i.lovenkov on 21.04.17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

require('./UserInfoRowItemView.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  UserInfoRowItemView: {
    displayName: 'UserInfoRowItemView'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/usr/local/ibonus/src/components/UserProfile/UserInfoRowItem/default/UserInfoRowItemView.jsx',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var UserInfoRowItemView = _wrapComponent('UserInfoRowItemView')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(UserInfoRowItemView, _Component);

  function UserInfoRowItemView(props) {
    (0, _classCallCheck3.default)(this, UserInfoRowItemView);
    return (0, _possibleConstructorReturn3.default)(this, (UserInfoRowItemView.__proto__ || (0, _getPrototypeOf2.default)(UserInfoRowItemView)).call(this, props));
  }

  (0, _createClass3.default)(UserInfoRowItemView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          user = _props.user,
          id = _props.id,
          lang = _props.lang;

      var fieldName = id === 'username' ? 'name' : id;

      return _react3.default.createElement(
        'div',
        { className: 'form-group col-sm-12 col-xs-12' },
        _react3.default.createElement(
          'div',
          { className: 'row' },
          _react3.default.createElement(
            'div',
            { className: 'col-xs-3 col-md-2' },
            _react3.default.createElement(
              'label',
              {
                htmlFor: fieldName,
                className: 'control-label'
              },
              lang[this.props.label]
            )
          ),
          _react3.default.createElement(
            'div',
            { className: 'col-xs-7 col-md-8' },
            _react3.default.createElement('input', {
              className: 'form-control le-input',
              disabled: !this.props.disabled,
              id: fieldName,
              onChange: this.props.onChange,
              type: 'text',
              value: this.props.value
            }),
            this.props.validate[fieldName] ? _react3.default.createElement(
              'div',
              null,
              _react3.default.createElement('i', { className: 'fa fa-exclamation-circle input_after_icon' }),
              _react3.default.createElement(
                'span',
                null,
                this.props.validate[fieldName]
              )
            ) : null,
            !this.props.currentValue || !this.props.value ? _react3.default.createElement(
              'div',
              null,
              _react3.default.createElement('i', { className: 'fa fa-exclamation-circle input_after_icon' }),
              fieldName === 'name' ? _react3.default.createElement(
                'span',
                null,
                lang['store.user_info_row_item.enter_name']
              ) : _react3.default.createElement(
                'span',
                null,
                lang['store.user_info_row_item.required']
              )
            ) : null,
            user[fieldName] && fieldName !== 'name' && !user.confirmed['confirmed_' + id] && !user.confirmed[id] && this.props.value ? _react3.default.createElement(
              'div',
              { className: 'accept-area' },
              _react3.default.createElement('i', { className: 'fa fa-exclamation-circle input_after_icon' }),
              _react3.default.createElement(
                'a',
                { onClick: function onClick() {
                    _this2.props.onClickConfirm(id);
                  } },
                lang['store.user_info_row_item.confirm']
              )
            ) : null
          ),
          _react3.default.createElement(
            'div',
            { className: 'col-xs-2 edit_buttons_wrap' },
            !this.props.disabled ? _react3.default.createElement(
              'button',
              {
                className: 'edit_pencil',
                'data-show': !this.props.disabled,
                onClick: this.props.onClickChange,
                type: 'button'
              },
              _react3.default.createElement('i', { className: 'fa fa-pencil-square' })
            ) : null,
            _react3.default.createElement(
              'button',
              {
                className: 'edit_cancel',
                'data-show': !this.props.disabled,
                onClick: this.props.onClickCancel,
                type: 'button'
              },
              _react3.default.createElement('i', { className: 'fa fa-window-close' })
            ),
            _react3.default.createElement(
              'button',
              {
                className: 'edit_ok',
                'data-show': !this.props.disabled,
                onClick: this.props.onClickAccept,
                type: 'button'
              },
              _react3.default.createElement('i', { className: 'fa fa-check-square' })
            )
          )
        )
      );
    }
  }]);
  return UserInfoRowItemView;
}(_react2.Component), _class.propTypes = {
  currentValue: _react2.PropTypes.string,
  description: _react2.PropTypes.string,
  disabled: _react2.PropTypes.bool,
  id: _react2.PropTypes.string,
  label: _react2.PropTypes.string,
  lang: _react2.PropTypes.object,
  onChange: _react2.PropTypes.func,
  onClickAccept: _react2.PropTypes.func,
  onClickCancel: _react2.PropTypes.func,
  onClickChange: _react2.PropTypes.func,
  onClickConfirm: _react2.PropTypes.func,
  user: _react2.PropTypes.object,
  validate: _react2.PropTypes.object,
  value: _react2.PropTypes.string
}, _temp));

exports.default = UserInfoRowItemView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/UserInfoRowItem/default/UserInfoRowItemView.jsx
// module id = 1780
// module chunks = 0